<script lang="ts">
  export let label = '';
  export let loading: boolean = false;
  export let cursor: 'default' | 'pointer' = 'pointer';
  export let variant: 'yellow' | 'blue' | 'link' | 'clear' | 'clear-white' = 'clear';
  export let short: boolean = false;
  export let shadow: boolean = false;
  export let disabled: boolean = false;
</script>

<button
  on:click
  disabled={disabled}
  class="c-button
        { cursor === 'default' ? 'cursor-default' : 'cursor-pointer' }
        { shadow ? 'shadow-button' : '' }
        { short ? 'min-w-fit' : 'min-w-[148px] md:min-w-[168px]' } 
        { variant === 'clear' ? 'c-button--clear' : '' } 
        { variant === 'clear-white' ? 'c-button--clear-white' : '' } 
        { variant === 'yellow' ? 'c-button--yellow' : '' }
        { variant === 'link' ? 'c-button--link' : '' }
        { variant === 'blue' ? 'c-button--blue' : '' }"
>
  <img class:hidden={!loading} class="animate-rotateIcon mr-2" src="images/loading-spinner.png" alt="loading icon">
  {label}
  <slot />
</button>

<style lang="scss">
  .c-button {
    @apply inline-flex items-center justify-center;
    @apply px-6 h-12;
    @apply text-black active:text-white;
    @apply active:bg-black;
    @apply border rounded-lg border-black border-opacity-25 hover:border-opacity-100;
    @apply text-base md:text-xxs;

    &:disabled,
    &[disabled]{
      @apply opacity-[0.6] pointer-events-none;
    }

    &--clear {
      @apply focus:border-black;
    }

    &--clear-white {
      @apply text-white border-white active:bg-transparent;
    }

    &--yellow {
      @apply border-yellow-light bg-yellow-light hover:bg-yellow-medium focus:border-yellow-dark active:bg-yellow-dark active:text-black;
    }

    &--link {
      @apply p-0 min-w-0 h-[fit-content] text-blue-dark font-medium active:bg-transparent active:border-none focus:bg-transparent focus:border-none active:text-blue-dark border-none;
    }

    &--blue {
      @apply border-blue-button-light bg-blue-button-light hover:bg-blue-button-medium focus:border-blue-button-dark active:bg-blue-button-dark text-white;
    }
  }
</style>